import { render, staticRenderFns } from "./DataViewUI.vue?vue&type=template&id=18050224&"
import script from "./DataViewUI.vue?vue&type=script&lang=js&"
export * from "./DataViewUI.vue?vue&type=script&lang=js&"
import style0 from "./DataViewUI.vue?vue&type=style&index=0&id=18050224&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports